import routie from "routie";
import { EventSystem } from "../EventSystem";
import { getModuleLog } from "../Logger";

/**
 * Routes URL's to events. This uses https://github.com/jgallen23/routie for the implementation.
 *
 * Routes are of the form http:://cavedb/#/place/{id} to allow navigation without page reloads and
 * to avoid server side complications.
 */
export class Router {
    private _log = getModuleLog("router");
    private _attachingPlaceRoute = false;

    constructor(private readonly _events: EventSystem) {
        routie({
            "/": () => {
                if (!this._attachingPlaceRoute) {
                    this._raiseEvent("ds-navigate-home");
                }
            },
        });
        routie({
            "/changelog": () => {
                if (!this._attachingPlaceRoute) {
                    this._raiseEvent("ds-navigate-changelog");
                }
            },
        });
        routie({
            "/moderation": () => {
                if (!this._attachingPlaceRoute) {
                    this._raiseEvent("ds-navigate-moderation");
                }
            },
        });
        routie({
            "/settings": () => {
                if (!this._attachingPlaceRoute) {
                    this._raiseEvent("ds-navigate-settings");
                }
            },
        });
        routie({
            "/uploads": () => {
                if (!this._attachingPlaceRoute) {
                    this._raiseEvent("ds-navigate-uploads");
                }
            },
        });
        routie({
            "/navigate/:lat/:lon": (lat: number, lon: number) => {
                this._raiseEvent("ds-navigate", {
                    location: {
                        lat,
                        lon,
                    },
                });
            },
        });
        routie({
            "/place/:id": (id: string) => {
                this._raiseEvent("ds-navigate-view-place", id);
            },
        });
        routie({
            "/user/:id": (id: string) => {
                this._raiseEvent("ds-navigate-view-user", id);
            },
        });
        if (location.hash === "") {
            routie("/");
        }
    }

    navigate(url: string, options: { silent: boolean } = { silent: false }) {
        routie.navigate(url, options);
    }

    private _raiseEvent(event: string, arg: any = {}) {
        this._log.debug(`${event}(${JSON.stringify(arg)})`);
        this._events.raiseEvent(event, arg);
    }
}
